import {
    autoUpdate,
    flip,
    FloatingPortal,
    offset,
    shift,
    useDismiss,
    useFloating,
    useFocus,
    useHover,
    useInteractions,
    useRole,
} from "@floating-ui/react";
import { ReactNode, useState } from "react";

type TooltipProps = {
    children: ReactNode;
    text: string;
};

const Tooltip = ({ children, text }: TooltipProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        placement: "top",
        whileElementsMounted: autoUpdate,
        middleware: [
            offset(5),
            flip({
                fallbackAxisSideDirection: "start",
            }),
            shift(),
        ],
    });

    const hover = useHover(context, { move: false });
    const focus = useFocus(context);
    const dismiss = useDismiss(context);
    const role = useRole(context, { role: "tooltip" });

    const { getReferenceProps, getFloatingProps } = useInteractions([hover, focus, dismiss, role]);

    return (
        <>
            <button ref={refs.setReference} {...getReferenceProps()}>
                {children}
            </button>
            {isOpen && (
                <FloatingPortal>
                    <div
                        ref={refs.setFloating}
                        className="z-2000 w-max bg-zinc-500 text-white text-sm py-1 px-2 rounded-sm"
                        style={floatingStyles}
                        {...getFloatingProps()}
                    >
                        {text}
                    </div>
                </FloatingPortal>
            )}
        </>
    );
};

export default Tooltip;
